import { colors, spacers } from '@hulu/design-tokens';
import { ThemeBranch } from './types';

export type TextFieldTheme = ThemeBranch<{
  TrekTextField: {
    pallete: {
      foreground: string;
      errorForeground: string;
      borderColor: string;
      hoverBorder: string;
      errorBorder: string;
      editableHoverBtnIcon: string;
      disabledBorder: string;
      background: string;
      disabledBackground: string;
    };
    sizes: {
      height: string;
      borderRadius: string;
      fontSize: string;
      padding: string;
      activePadding: string;
    };
  };
}>;

export const DefaultTheme: TextFieldTheme = {
  TrekTextField: {
    pallete: {
      foreground: colors.colorFauxBlack,
      errorForeground: colors.colorRedBase,
      borderColor: colors.colorGray4,
      hoverBorder: colors.colorGray3,
      errorBorder: colors.colorRedBase,
      editableHoverBtnIcon: colors.colorGray2,
      disabledBorder: colors.colorGray3,
      background: colors.colorWhite,
      disabledBackground: colors.colorGray5,
    },
    sizes: {
      height: '40px',
      borderRadius: '4px',
      fontSize: '14px',
      padding: `9.5px ${spacers.spacer03}`,
      activePadding: '8.5px 11px',
    },
  },
};
